<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card class="elevation-0">
        <v-btn v-if="mode=='view'" @click="mode='add'" fab absolute right top class="mt-5 primary">Add</v-btn>
        <v-card-title class="layout justify-center">
          <h1>Edit Images</h1>
        </v-card-title>
        <v-container grid-list-sm fluid v-if="images.length > 0 && mode==='view'">
          <v-layout row wrap>
            <v-flex
              v-for="image in images"
              :key="image.key"
              xs4
              d-flex
            >
              <v-hover>
              <v-card 
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 24 : 2}`" :style="{cursor: hover ? 'pointer' : 'default'}">
                  <v-img
                    :src="image.src"
                    :lazy-src="`https://picsum.photos/10/6?image=1`"
                    aspect-ratio="0.7"
                    class="grey lighten-2"
                    max-height="200px"
                  >
                    <v-layout
                      slot="placeholder"
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </v-img>
                  <v-card-title primary-title>
                    <div>
                      <v-btn @click="setEditImage(image)" fab absolute top left small style="left:5px" class="mt-4"><v-icon>edit</v-icon></v-btn>
                      <div>Name: {{image.name}}</div>
                      <div>Cost: {{image.cost}}</div>
                    </div>
                  </v-card-title>
              </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container>
          <v-form v-if="mode === 'add' || mode === 'update'">
            <v-select 
            :items="['wedding', 'birthday', 'cupcakes', 'other']"
            label="Type"
            v-model="imageType"></v-select>
            <v-text-field v-model="imageName" required label="Name" ></v-text-field>
            <v-text-field v-model="imageCost" required label="Cost"></v-text-field>
            <input v-if="mode === 'add'" id="file-input" type="file"/>
            <br>
            <v-btn @click="mode = 'view'">Cancel</v-btn>
            <v-btn @click="sendData" :loading="loading">Submit</v-btn>
            <v-btn @click="deleteData" color="error" v-if="mode != 'add'" :loading="loading">Delete</v-btn>
          </v-form>
        </v-container>
        <v-progress-linear v-if="images.length < 1" :indeterminate="true"></v-progress-linear>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
export default {
  data () {
    return {
      gallery: false,
      activeImage: -1,
      images: [],
      mode: 'view',
      imageName: '',
      imageType: 'wedding',
      imageCost: '',
      activeKey: '',
      loading: false
    }
  },
  mounted () {
    this.getImages()
  },
  methods: {
    getImages () {
      let images = []
      firebase.database().ref('images').once('value')
        .then(snap => {
          for (let image in snap.val()) {
            let imageObj = snap.val()[image]
            imageObj.key = image
            images.push(imageObj)
          }
        })
      this.images = images
    },
    setEditImage (image) {
      this.mode = 'update'
      this.activeKey = image.key
      this.imageType = image.type
      this.imageName = image.name
      this.imageCost = image.cost
    },
    resetApp () {
      this.loading = false
      this.getImages()
      this.mode = 'view'
    },
    sendData () {
      if (this.loading === false) {
        this.loading = true
        if (this.mode === 'add') {
          const file = document.getElementById('file-input').files[0]
          const timestamp = Date.now()
          firebase.storage().ref('images/' + timestamp + '.jpg').put(file)
            .then(() => {
              firebase.storage().ref('images/' + timestamp + '.jpg').getDownloadURL()
                .then((URL) => {
                  firebase.database().ref('images').push({
                    type: this.imageType,
                    name: this.imageName,
                    cost: this.imageCost,
                    src: URL
                  }).then(() => {
                    this.resetApp()
                  })
                })
            })
        } else {
          firebase.database().ref('images').child(this.activeKey).update({
            type: this.imageType,
            name: this.imageName,
            cost: this.imageCost
          }).then(() => {
            this.resetApp()
          })
        }
      }
    },
    deleteData () {
      if (this.loading === false) {
        this.loading = true
        firebase.database().ref('images').child(this.activeKey).remove()
          .then(() => {
            this.resetApp()
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Edit.vue